import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const setPushSubscriptionState = createAction(`${reduxKey}/SET_PUSH_SUBSCRIPTION_STATE`, (newState)=>({
        newState
    }));
export const togglePushSubscription = createAction(`${reduxKey}/TOGGLE_PUSH_SUBSCRIPTION`, ()=>({}));

//# sourceMappingURL=actions.js.map